export default __webpack_public_path__ + "static/PromptIconThree-1fd50c2f3b7ce882724d53150a7695d1.png";